import React from 'react';
import { useNavigate } from "react-router-dom";
import {
  FluentProvider,
  teamsLightTheme,
  Button,
} from '@fluentui/react-components';
import { Warning24Regular } from '@fluentui/react-icons';

const IncorrectDetailsScene = () => {
  const navigate = useNavigate();

  return (
    <FluentProvider theme={teamsLightTheme}>
      <div style={{
        minHeight: '90vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        padding: 20,
        maxWidth: 500,
        margin: '0 auto',
        background: '#fff',
        boxSizing: 'border-box'
      }}>
        <div>
          <Button 
            appearance="subtle" 
            icon={<span style={{display:'inline-block',transform:'rotate(180deg)'}}>&#8594;</span>} 
            onClick={() => navigate(-1)} 
            aria-label="Back" 
          />
        </div>

        <div style={{ 
          flex: 1, 
          display: 'flex', 
          flexDirection: 'column', 
          justifyContent: 'center', 
          alignItems: 'center', 
          textAlign: 'center',
          gap: '2rem'
        }}>
          <div>
            <div style={{ fontWeight: 'bold', fontSize: '1.2rem', marginBottom: '0.5rem' }}>
              Health Partners Note Assistant
            </div>
          </div>

          <div
            style={{
              backgroundColor: '#FDF2F2',
              color: '#B91C1C',
              borderRadius: 8,
              padding: '24px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 16,
              fontSize: '1rem',
              border: '1px solid #FECACA',
              maxWidth: '400px'
            }}
          >
            <Warning24Regular style={{ fontSize: '2rem' }} />
            <div style={{ fontWeight: 600, fontSize: '1.1rem' }}>
              Details Update Required
            </div>
            <div style={{ lineHeight: '1.5' }}>
              Please update the details in the <strong>GW2 portal</strong> and refresh the app to continue.
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 24 }}>
          <Button 
            appearance="primary" 
            onClick={() => navigate("/")}
            style={{ minWidth: '120px' }}
          >
            Go to Start
          </Button>
        </div>
      </div>
    </FluentProvider>
  );
};

export default IncorrectDetailsScene;